import { render, staticRenderFns } from "./edit-company-document.vue?vue&type=template&id=eb2df654&scoped=true&"
import script from "./edit-company-document.vue?vue&type=script&lang=js&"
export * from "./edit-company-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2df654",
  null
  
)

export default component.exports